import { create } from 'zustand';

interface QuestionnaireWizardState {
  isWizardOpen: boolean;
  questionnaireId: string | null;
  openWizard: (questionnaireId?: string) => void;
  closeWizard: () => void;
}

export const useQuestionnaireWizardStore = create<QuestionnaireWizardState>((set) => ({
  isWizardOpen: false,
  questionnaireId: null,
  openWizard: (questionnaireId?: string) => set({ isWizardOpen: true, questionnaireId: questionnaireId || null }),
  closeWizard: () => set({ isWizardOpen: false, questionnaireId: null }),
}));